import * as actionTypes from './../actions/productsAction';
import * as productTypes from './../../containers/Products/ProductsValues';

const initialState = {
  selected: [],
  selectedData: {},
  selectedCategory: null,
  data: [],
  pending: true,
  error: null,
  ready: false,
  animalType: null,
  availableCategories: []
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SELECT:
      let newSelectedData = {...state.selectedData};
      newSelectedData[action.selected]=action.selectedData;
      return {
        ...state,
        selected: [...state.selected, action.selected],
        selectedData: newSelectedData,
      };
    case actionTypes.SELECT_CATEGORY:
      return {
        ...state,
        selectedCategory: action.selectedCategory,
      };
    case actionTypes.AVAILABLE_CATEGORIES:
      return {
        ...state,
        availableCategories: action.availableCategories
      };
    case actionTypes.REMOVE:
      const index = state.selected.indexOf(action.removed);
      let selectedArray = [...state.selected];
      let newSelectedData2 = {...state.selectedData};
      if (index > -1) {
        selectedArray.splice(index, 1);
        delete newSelectedData2[action.removed];
      }
      return {
        ...state,
        selected: selectedArray,
        selectedData: newSelectedData2,
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        selected: [],
        selectedCategory: productTypes.DRY_FOOD,
        availableCategories: [
          productTypes.DRY_FOOD,
          productTypes.WET_FOOD,
          productTypes.RELATED,
          productTypes.SNACKS
        ],
        selectedData: {},
        ready: true,
        animalType: action.animalType,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case actionTypes.RESET_PRODUCTS:
      return {
        ...state,
        selected: [],
        selectedCategory: productTypes.DRY_FOOD,
        selectedData: {},
        ready: true,
      };

    default:
      return state;
  }
};

export default reducer;
